export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9622.0e8fd286.jpg";